module.exports = __webpack_public_path__ + "img/6.a2ab1dbc.png";